$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

function pixImageUrl(mode, size, path, nocache) {
    if (nocache) mode = 'nocache-' + mode;
    return '/piximage/' + mode + '/' + size + path;
}

$('.jsLink').click(function () {
    window.location.href = $(this).data('url');
});

function fancyUpdate() {
    $(".fancy").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        helpers: {
            overlay: {
                locked: false
            }
        }
    });

    $(".fancybox-thumb").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        helpers: {
            title: {
                type: 'outside'
            },
            thumbs: {
                width: 100,
                height: 100
            },
            overlay: {
                locked: false
            }
        }
    });

    $(".fancybox-frame-thumb").fancybox({
        prevEffect: 'none',
        nextEffect: 'none',
        arrows: false,
        helpers: {
            title: {
                type: 'outside'
            },
            thumbs: {
                width: 100,
                height: 100
            },
            overlay: {
                locked: false
            }
        }
    });
}
$(function () {
    fancyUpdate();
});
SyntaxHighlighter.all({
    toolbar: false
});
function updateAddCommentForm() {
    $('.addCommentForm').ajaxForm({
        beforeSubmit: function (arr, form, options) {
            $(form).find('button').addClass('disabled');
            $(form).find('.errors').html('');
        },
        data: {'antiBot': 1},
        success: function (data, statusText, xhr, form) {
            if (data.errors) {
                $(form).find('button').removeClass('disabled');
                var html = '<ul>';
                $.each(data.errors, function (index, value) {
                    html += '<li>' + value + '</li>';
                });
                html += '</ul>';
                $(form).find('.errors').html(html);
            } else {
                location.hash = '#comment-' + data.commentId;
                location.reload();
            }
        }
    });
}
updateAddCommentForm();

function commentReply(parentId) {
    $('.commentsList .item .addComment').remove();
    var newCommentForm = $('.addComment').clone();
    newCommentForm.find('input[name=parentId]').val(parentId);
    newCommentForm.find('.h2').remove();
    $('#comment-' + parentId + ' > .reply').after(newCommentForm);
    newCommentForm.find('textarea').focus();
    updateAddCommentForm();
}

function startStickyBlock() {
    var stickyElement = $('.stickyBlock');
    if (!stickyElement.length)
        return;
    $('<div class="clear" id="stickyBlockTop"></div>').insertBefore(stickyElement);
    var stickyBlockTopElement = $('#stickyBlockTop');
    var footerElement = $('footer');

    function stickyBlockCheck() {
        var scrollPosition = $(document).scrollTop();
        var stickyHeight = stickyElement.outerHeight();
        if (scrollPosition > stickyBlockTopElement.offset().top && $(window).width() >= 1041) {
            if (scrollPosition + stickyHeight > footerElement.offset().top) {
                stickyElement.css({
                    'top': footerElement.offset().top - (scrollPosition + stickyHeight) + 'px',
                    'position': 'fixed',
                    'width': stickyBlockTopElement.width() + 'px'
                });
            } else {
                stickyElement.css({
                    'top': 0,
                    'position': 'fixed',
                    'width': stickyBlockTopElement.width() + 'px'
                });
            }
        } else {
            stickyElement.removeAttr('style');
        }
    }

    $(window).scroll(stickyBlockCheck);
    $(window).resize(stickyBlockCheck);
}
startStickyBlock();


function addKworkBanner() {
    var html = '<a href="https://kwork.ru?ref=45128" target="_blank" style="margin-top: 25px; display: block"><img src="https://kwork.ru/images/partner/336x280.jpg" width="300" alt="Kwork.ru - услуги фрилансеров по 500 руб."></a>';
    $('.rightCol .articleRotation').append(html)
}
addKworkBanner();